<script>
  import { onDestroy, onMount } from "svelte";
  import ItemResponse from "./ItemResponse.svelte";
  import { dataInfo, currentSpec } from "../../editor/storage.js";
  import { Label, Input, Collapse } from "sveltestrap";
  import { findLayer, unfindLayer } from "../../editor/component/mark.js";
  import { dTypeEmoji } from "../../editor/component/data.js";

  export let inputFocusAction;
  export let inputBlurAction;
  export let label;
  export let updateMarkLabel;
  export let creator;
  export let layerNumberLimit;
  export let afterDelete;
  export let isLineLike = false;

  let showPositioning = true,
    showDataLinking = true,
    showTicks = true;
  let newDesign = { layer: {}, field: undefined, values: [] };
  let newCustomValue, newCustomText;
  let showTextLine = label === "new" ? undefined : label?.items.map(() => true);
  onMount(() => {
    showTextLine = label === "new" ? undefined : label?.items.map(() => true);
    newCustomValue = undefined;
    newCustomText = undefined;
    showPositioning = true;
    showDataLinking = true;
    showTicks = true;
  });
  onDestroy(() => {
    newCustomValue = undefined;
    newCustomText = undefined;
  });
  currentSpec.subscribe((spec) => {
    showTextLine =
      label === "new"
        ? undefined
        : label?.items.map((_, i, arr) =>
            (i == 0 && arr.length == 1) || showTextLine?.[i] ? true : false
          );
    newCustomValue = undefined;
    newCustomText = undefined;
  });
</script>

{#if label === "new"}
  <!-- Composition -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <h3 class="h-sub">Data linking</h3>
    </div>
  </div>
  <!-- Layer -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <Label for="layer">Layer</Label>
    </div>
    <div class="dupo-menu-pane-form-row">
      <Input
        type="select"
        name="layer"
        id="layer"
        class="custom-form-select"
        bind:value={newDesign.layer}
        on:focus={(event) => {
          if (newDesign.layer.name)
            unfindLayer(
              $currentSpec.uid,
              newDesign.layer.name,
              layerNumberLimit
            );
          inputFocusAction(event);
        }}
        on:blur={(event) => {
          inputBlurAction(event);
        }}
        on:change={() => {
          if (newDesign.layer.name)
            findLayer($currentSpec.uid, newDesign.layer.name, layerNumberLimit);
        }}
      >
        <option value={undefined} />
        {#each $currentSpec?.fronto?.layer as layer, li}
          <option value={layer}
            >{layer.name || "layer " + (li + 1)} (mark: {layer.mark
              ?.type})</option
          >
        {/each}
      </Input>
    </div>
  </div>
  <!-- Field -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <Label for="field">Field</Label>
    </div>
    <div class="dupo-menu-pane-form-row">
      <Input
        type="select"
        name="field"
        id="field"
        class="custom-form-select"
        bind:value={newDesign.field}
        on:focus={inputFocusAction}
        on:blur={inputBlurAction}
        on:change={(event) => {
          if (
            $dataInfo?.stats?.[event.target.value].type === "nominal" ||
            $dataInfo?.stats?.[event.target.value].type === "ordinal"
          )
            newDesign.values = $dataInfo?.stats?.[event.target.value]?.values;
        }}
      >
        <option value={undefined} selected />
        {#each $dataInfo?.columns as field}
          <option value={field}
            >{dTypeEmoji[
              $dataInfo?.stats?.[field]?.type
            ]}&nbsp;&nbsp;{field}</option
          >
        {/each}
      </Input>
    </div>
  </div>
  <!-- Values -->
  <div class="dupo-menu-pane mb-2">
    <ItemResponse
      type="values"
      title="Values"
      token="values"
      pickerX="290px"
      pickerY="230px"
      {inputFocusAction}
      {inputBlurAction}
      field={newDesign.field}
      value={newDesign.values || []}
      changeAction={(event) => {
        newDesign.values = event.target.value;
      }}
    />
  </div>
  <!-- CREATE -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-button-row">
      <button
        on:click={(event) => {
          creator(event, newDesign);
        }}><i class="bi bi-plus-circle me-1" />Create</button
      >
    </div>
  </div>
{:else if label}
  <!-- Composition -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <h3
        class="h-sub handle-collapse"
        on:click={() => {
          showDataLinking = !showDataLinking;
        }}
      >
        <i
          class={`bi bi-caret-${showDataLinking ? "down-fill" : "right"} me-1`}
        /> Data linking
      </h3>
    </div>
  </div>
  <Collapse isOpen={showDataLinking}>
    <!-- Name -->
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row">
        <Label for="name">Name</Label>
      </div>
      <div class="dupo-menu-pane-form-row">
        <Input
          type="text"
          name="name"
          id="name"
          class="custom-form-select"
          value={label.name}
          on:focus={inputFocusAction}
          on:blur={inputBlurAction}
          on:change={(event) => {
            let values;
            if (
              $dataInfo?.stats?.[event.target.value].type === "nominal" ||
              $dataInfo?.stats?.[event.target.value].type === "ordinal"
            )
              values = $dataInfo?.stats?.[event.target.value]?.values;
            updateMarkLabel(event, "label.name", label, { values });
          }}
        />
      </div>
    </div>
    <!-- Layer -->
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row">
        <Label for="layer">Layer</Label>
      </div>
      <div class="dupo-menu-pane-form-row">
        <Input
          type="select"
          name="layer"
          id="layer"
          class="custom-form-select"
          value={label?.layerName}
          on:focus={(event) => {
            inputFocusAction(event);
          }}
          on:blur={(event) => {
            inputBlurAction(event);
          }}
          on:change={(event) => {
            updateMarkLabel(event, "layer", label);
          }}
        >
          <option value={undefined} />
          {#each $currentSpec?.fronto?.layer as layer, li}
            <option value={layer.name}
              >{layer.name || "layer " + (li + 1)} (mark: {layer.mark
                ?.type})</option
            >
          {/each}
        </Input>
      </div>
    </div>
    <!-- Field -->
    <div class="dupo-menu-pane mb-2">
      <div class="dupo-menu-pane-row">
        <Label for="field">Field</Label>
      </div>
      <div class="dupo-menu-pane-form-row">
        <Input
          type="select"
          name="field"
          id="field"
          class="custom-form-select"
          value={label.field}
          on:focus={inputFocusAction}
          on:blur={inputBlurAction}
          on:change={(event) => {
            let values;
            if (
              $dataInfo?.stats?.[event.target.value].type === "nominal" ||
              $dataInfo?.stats?.[event.target.value].type === "ordinal"
            )
              values = $dataInfo?.stats?.[event.target.value]?.values;
            updateMarkLabel(event, "label.field", label, { values });
          }}
        >
          <option value={undefined} selected />
          {#each $dataInfo?.columns as field}
            <option value={field}
              >{dTypeEmoji[
                $dataInfo?.stats?.[field]?.type
              ]}&nbsp;&nbsp;{field}</option
            >
          {/each}
        </Input>
      </div>
    </div>
    <!-- Values -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="values"
        title="Values"
        token="values"
        pickerX="290px"
        pickerY="230px"
        {inputFocusAction}
        {inputBlurAction}
        field={label.field}
        value={label.values || []}
        changeAction={(event) => {
          updateMarkLabel(event, "label.values", label);
        }}
      />
    </div>
  </Collapse>
  <div class="pane-divider" />
  <!-- Positioning -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <h3
        class="h-sub handle-collapse"
        on:click={() => {
          showPositioning = !showPositioning;
        }}
      >
        <i
          class={`bi bi-caret-${showPositioning ? "down-fill" : "right"} me-1`}
        /> Positioning
      </h3>
    </div>
  </div>
  <!-- Positioing -->
  <Collapse isOpen={showPositioning}>
    {#if !isLineLike}
      <!-- Orient -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="orient"
          title="Orient"
          token="orient"
          {inputFocusAction}
          {inputBlurAction}
          value={label.orient}
          tblr9pos={true}
          topBottom={false}
          leftRight={false}
          tblr6pos={false}
          tblr4pos={false}
          changeAction={(event) => {
            updateMarkLabel(event, "label.orient", label);
          }}
        />
      </div>
      <!-- Anchor -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="anchor"
          title="Anchor"
          token="anchor"
          {inputFocusAction}
          {inputBlurAction}
          value={label.anchorAlign}
          changeAction={(event) => {
            updateMarkLabel(event, "label.anchor", label);
          }}
        />
      </div>
    {/if}
    <!-- dx -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="number"
        title="Relative X positoin (dx)"
        token="dx"
        {inputFocusAction}
        {inputBlurAction}
        value={label.dx}
        changeAction={(event) => {
          updateMarkLabel(event, "label.dx", label);
        }}
      />
    </div>
    <!-- dy -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="number"
        title="Relative Y positoin (dy)"
        token="dy"
        {inputFocusAction}
        {inputBlurAction}
        value={label.dy}
        changeAction={(event) => {
          updateMarkLabel(event, "label.dy", label);
        }}
      />
    </div>
    <!-- angle -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="angle"
        token={"angle"}
        title="Angle"
        {inputFocusAction}
        {inputBlurAction}
        value={label.angle}
        changeAction={(event) => {
          updateMarkLabel(event, "label.angle", label);
        }}
      />
    </div>
    <!-- Externalized -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="inline-check"
        title="Externalize"
        token="externalize"
        {inputFocusAction}
        {inputBlurAction}
        value={label.visibility?.externalize !== undefined}
        changeAction={(event) => {
          updateMarkLabel(event, "label.externalize", label);
        }}
      />
    </div>
    <!-- If externalized: numbering -->
    {#if label.visibility?.externalize !== undefined}
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="inline-check"
          title="Numbering"
          token="numbering"
          {inputFocusAction}
          {inputBlurAction}
          value={label.visibility?.externalize?.numbering}
          changeAction={(event) => {
            updateMarkLabel(event, "label.numbering", label);
          }}
        />
      </div>
    {/if}
  </Collapse>

  <div class="pane-divider" />
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <h3 class="h-sub">Text lines</h3>
    </div>
  </div>
  <!-- Formatting per Line-->
  {#if label?.items}
    {#each label?.items as text, ti}
      <div class="dupo-menu-pane">
        <div class="dupo-menu-pane-row">
          <div
            class="menu-second-level handle-collapse"
            on:click={() => {
              showTextLine[ti] = !showTextLine[ti];
              if (showTextLine[ti]) {
                showDataLinking = false;
                showPositioning = false;
                showTicks = false;
              }
            }}
          >
            <i
              class={`bi bi-caret-${
                showTextLine[ti] ? "down-fill" : "right"
              } me-1`}
            />Text line {ti + 1}
          </div>
        </div>
      </div>
      <Collapse isOpen={showTextLine[ti]}>
        <!-- Values -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="values"
            title="Values"
            token={`label-items-${ti}-values`}
            pickerX="290px"
            pickerY="430px"
            {inputFocusAction}
            {inputBlurAction}
            field={label.field}
            value={text.values || []}
            changeAction={(event) => {
              updateMarkLabel(event, `label.items.${ti}.values`, label);
            }}
          />
        </div>
        <!-- Layout -->
        <div class="dupo-menu-pane mb-2">
          <div class="dupo-menu-pane-row">
            <h3 class="h-sub">Layout</h3>
          </div>
        </div>
        <!-- Width -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="width"
            title="Width"
            token={`label-items-${ti}-width`}
            {inputFocusAction}
            {inputBlurAction}
            value={text.width}
            changeAction={(event) => {
              updateMarkLabel(event, `label.items.${ti}.width`, label);
            }}
          />
        </div>
        <!-- Align -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="textAlign"
            title="Text align"
            token={`label-items-${ti}-align`}
            {inputFocusAction}
            {inputBlurAction}
            value={text.textAlign}
            changeAction={(event) => {
              updateMarkLabel(event, `label.items.${ti}.align`, label);
            }}
          />
        </div>

        <div class="pane-divider" />
        <!-- Font style -->
        <div class="dupo-menu-pane mb-2">
          <div class="dupo-menu-pane-row">
            <h3 class="h-sub">Font style</h3>
          </div>
        </div>
        <!-- Font size -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="fontSize"
            title="Font size"
            token={`label-items-${ti}-fontSize`}
            {inputFocusAction}
            {inputBlurAction}
            value={text.fontSize || 16}
            changeAction={(event) => {
              updateMarkLabel(event, `label.items.${ti}.fontSize`, label);
            }}
          />
        </div>
        <!-- Font weight -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="fontWeight"
            title="Font weight"
            token={`label-items-${ti}-fontWeight`}
            {inputFocusAction}
            {inputBlurAction}
            value={text.fontWeight}
            changeAction={(event) => {
              updateMarkLabel(event, `label.items.${ti}.fontWeight`, label);
            }}
          />
        </div>
        <!-- Color -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="color"
            title="Font color"
            token={`label-items-${ti}-color`}
            {inputFocusAction}
            {inputBlurAction}
            isMarkLabel={true}
            value={text.color || "rgba(0,0,0,0)"}
            changeAction={(event) => {
              updateMarkLabel(event, `label.items.${ti}.color`, label);
            }}
          />
        </div>
        <!-- Font Stroke Color -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="color"
            title="Font stroke color"
            token={`label-items-${ti}-fontStroke`}
            {inputFocusAction}
            {inputBlurAction}
            isMarkLabel={true}
            value={text.fontStroke || "rgba(0,0,0,0)"}
            changeAction={(event) => {
              updateMarkLabel(event, `label.items.${ti}.fontStroke`, label);
            }}
          />
        </div>
        <!-- Opacity -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="opacity"
            title="Font opacity"
            token={`label-items-${ti}-opacity`}
            {inputFocusAction}
            {inputBlurAction}
            isMarkLabel={true}
            value={text.opacity || 1}
            changeAction={(event) => {
              updateMarkLabel(event, `label.items.${ti}.opacity`, label);
            }}
          />
        </div>

        <div class="pane-divider" />
        <!-- Formatting -->
        <div class="dupo-menu-pane mb-2">
          <div class="dupo-menu-pane-row">
            <h3 class="h-sub">Text formatting</h3>
          </div>
        </div>

        <!-- Format -->
        <div class="dupo-menu-pane mb-2">
          <ItemResponse
            type="text"
            title="Format string"
            token={`label-items-${ti}-format`}
            {inputFocusAction}
            {inputBlurAction}
            value={text.format}
            changeAction={(event) => {
              updateMarkLabel(event, `label.items.${ti}.format`, label);
            }}
          />
        </div>
        <!-- Expression -->
        {#if label.field}
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="data-expression"
              title="Expression"
              token={`label-items-${ti}-expression`}
              {inputFocusAction}
              {inputBlurAction}
              value={text.expression}
              field={label.field}
              values={text.values || label.values || []}
              changeAction={(event) => {
                updateMarkLabel(event, `label.items.${ti}.expression`, label);
              }}
            />
          </div>
        {/if}

        <!-- Content -->
        {#if label.values?.length == 1 || text.values?.length == 1}
          <div class="dupo-menu-pane mb-2">
            <ItemResponse
              type="longText"
              title="Content (custom text)"
              token={`label-items-${ti}-content`}
              {inputFocusAction}
              {inputBlurAction}
              value={text.content || ""}
              changeAction={(event) => {
                updateMarkLabel(event, `label.items.${ti}.content`, label);
              }}
            />
          </div>
        {:else}
          <!-- Custom -->
          <div class="dupo-menu-pane mb-2">
            <div class="dupo-menu-pane-row">
              <Label for={"custom-" + ti}>Custom per value</Label>
            </div>

            {#if text.customList !== undefined}
              {#each text.customList as custom, ci}
                <div class="dupo-menu-pane-form-row d-flex">
                  <Label
                    for={"custom-" + ti + "-value-" + ci}
                    style="width: 43%;"
                    class="text-sm mb-0">Value {ci + 1}</Label
                  >
                  <Label
                    for={"custom-" + ti + "-text-" + ci}
                    style="width: 53%;"
                    class="text-sm mb-0">Text {ci + 1}</Label
                  >
                  <Label style="width: 4%;" class="text-sm mb-0">-</Label>
                </div>
                <div class="dupo-menu-pane-form-row mb-1 d-flex">
                  <div class="form-wrap">
                    <Input
                      id={"custom-" + ti + "-value-" + ci}
                      name={"custom-" + ti + "-value-" + ci}
                      type="text"
                      autocomplete="off"
                      class="custom-form-select"
                      style="width: 40%;"
                      on:focus={inputFocusAction}
                      on:blur={inputBlurAction}
                      bind:value={custom.value}
                      on:change={(event) => {
                        updateMarkLabel(
                          text.customList,
                          `label.items.${ti}.custom`,
                          label
                        );
                      }}
                    />
                    <Input
                      id={"custom-" + ti + "-text-" + ci}
                      name={"custom-" + ti + "-text-" + ci}
                      type="text"
                      autocomplete="off"
                      class="custom-form-select"
                      style="width: 50%;"
                      on:focus={inputFocusAction}
                      on:blur={inputBlurAction}
                      bind:value={custom.text}
                      on:change={(event) => {
                        updateMarkLabel(
                          text.customList,
                          `label.items.${ti}.custom`,
                          label
                        );
                      }}
                    />
                    <button
                      type="button"
                      class="custom-form-select"
                      style="width: 10%; padding-left: 0; padding-right: 0;"
                      on:click={(event) => {
                        text.customList.splice(ci, 1);
                        updateMarkLabel(
                          text.customList,
                          `label.items.${ti}.custom`,
                          label
                        );
                      }}
                      ><i
                        class="bi bi-trash-fill"
                        alt="delete this custom item"
                      /></button
                    >
                  </div>
                </div>
              {/each}
            {/if}
            <div class="dupo-menu-pane-form-row d-flex">
              <Label
                for={"custom-" + ti + "-value-new"}
                style="width: 43%;"
                class="text-sm mb-0">New value</Label
              >
              <Label
                for={"custom-" + ti + "-text-new"}
                style="width: 53%;"
                class="text-sm mb-0">New text</Label
              >
              <Label style="width: 4%;" class="text-sm mb-0">+</Label>
            </div>
            <div class="dupo-menu-pane-form-row mb-1 d-flex">
              <div class="form-wrap">
                <Input
                  id={"custom-" + ti + "-value-new"}
                  name={"custom-" + ti + "-value-new"}
                  type="text"
                  autocomplete="off"
                  class="custom-form-select"
                  style="width: 40%;"
                  on:focus={inputFocusAction}
                  on:blur={inputBlurAction}
                  bind:value={newCustomValue}
                />
                <Input
                  id={"custom-" + ti + "-text-new"}
                  name={"custom-" + ti + "-text-new"}
                  type="text"
                  autocomplete="off"
                  class="custom-form-select"
                  style="width: 50%;"
                  on:focus={inputFocusAction}
                  on:blur={inputBlurAction}
                  bind:value={newCustomText}
                />
                <button
                  type="button"
                  class="custom-form-select"
                  style="width: 10%; padding-left: 0; padding-right: 0;"
                  on:click={(event) => {
                    console.log(newCustomValue, newCustomText);
                    updateMarkLabel(
                      { newCustomValue, newCustomText },
                      `label.items.${ti}.custom`,
                      label
                    );
                    newCustomValue = undefined;
                    newCustomText = undefined;
                  }}
                  ><i
                    class="bi bi-plus-circle"
                    alt="add this custom item"
                  /></button
                >
              </div>
            </div>
          </div>
        {/if}
        <!-- todo: delete this line -->
        <div class="dupo-menu-pane mb-2">
          <div class="dupo-menu-pane-button-row">
            <button
              on:click={(event) =>
                updateMarkLabel("delete", `label.items.${ti}`, label)}
              ><i class="bi bi-eraser me-1" /> Delete this line</button
            >
          </div>
        </div>
      </Collapse>
    {/each}
  {/if}
  <!-- Add a new line -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-button-row">
      <button
        on:click={(event) => {
          updateMarkLabel("duplicate", "label.items", label);
          showTextLine.push(true);
        }}><i class="bi bi-plus-circle me-1" /> Add a new text line</button
      >
    </div>
  </div>

  <div class="pane-divider" />
  <!-- Tick -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-row">
      <h3
        class="h-sub handle-collapse"
        on:click={() => {
          showTicks = !showTicks;
        }}
      >
        <i class={`bi bi-caret-${showTicks ? "down-fill" : "right"} me-1`} /> Ticks
      </h3>
    </div>
  </div>
  <Collapse isOpen={showTicks}>
    <!-- Use tick -->
    <div class="dupo-menu-pane mb-2">
      <ItemResponse
        type="inline-check"
        title="Use tick"
        token="tick-ticks"
        {inputFocusAction}
        {inputBlurAction}
        value={label.tick?.ticks}
        changeAction={(event) => {
          updateMarkLabel(event, "label.tick.ticks", label);
        }}
      />
    </div>
    {#if label.tick?.ticks}
      <!-- Offset -->
      <div class="dupo-menu-pane">
        <ItemResponse
          type="size"
          title="Tick offset (from mark/label)"
          token="tick-offset"
          {inputFocusAction}
          {inputBlurAction}
          value={label.tick?.offset}
          changeAction={(event) => {
            updateMarkLabel(event, `label.tick.offset`, label);
          }}
        />
      </div>
      <!-- Tick Color -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="color"
          title="Tick stroke color"
          token="tick-color"
          {inputFocusAction}
          {inputBlurAction}
          value={label.tick?.color}
          changeAction={(event) => {
            updateMarkLabel(event, `label.tick.stroke`, label);
          }}
        />
      </div>
      <!-- Tick width -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="width"
          title="Tick stroke width"
          token="tick-width"
          {inputFocusAction}
          {inputBlurAction}
          value={label.tick?.width}
          changeAction={(event) => {
            updateMarkLabel(event, `label.tick.strokeWidth`, label);
          }}
        />
      </div>
      <!-- Opacity -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="opacity"
          title="Tick opacity"
          token="tick-opacity"
          {inputFocusAction}
          {inputBlurAction}
          value={label.tick?.opacity || 1}
          changeAction={(event) => {
            updateMarkLabel(event, `label.tick.opacity`, label);
          }}
        />
      </div>
      <!-- Dash -->
      <div class="dupo-menu-pane mb-2">
        <ItemResponse
          type="dash"
          title="Tick dash"
          token="tick-dash"
          {inputFocusAction}
          {inputBlurAction}
          value={label.tick?.dash}
          changeAction={(event) => {
            updateMarkLabel(event, `label.tick.dash`, label);
          }}
        />
      </div>
    {/if}
  </Collapse>
  <!-- lock -->
  <div class="pane-divider" />
  <div class="dupo-menu-pane pt-2">
    <ItemResponse
      type="lock"
      tooltipMessage="Prevent suggesting responsive alternatives that make changes to this mark labels. Element-Lock applies to its source or target design(s)."
      title="Lock this mark label design"
      token={"label-lock"}
      value={label.lock}
      {inputFocusAction}
      {inputBlurAction}
      changeAction={(event) => {
        updateMarkLabel(event, "lock", label);
      }}
    />
  </div>
  <div class="pane-divider mt-5" />
  <!-- Delete -->
  <div class="dupo-menu-pane mb-2">
    <div class="dupo-menu-pane-button-row">
      <button
        on:click={(event) => {
          updateMarkLabel("delete", "mark.label", label);
          afterDelete();
          unfindLayer();
        }}><i class="bi bi-eraser me-1" /> Delete this label</button
      >
    </div>
  </div>
{/if}
